<template>
  <div id="app" @click.stop="getIsshowarea">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
 provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    clickRoot(event){
      this.$store.dispatch("clickRootNumAction", 1);
    },
    getIsshowarea(){
      this.$store.state.isShowSelArea=false;
    },
  }
}
</script>

<style>
@import url('../static/css/ele_revised.css');



</style>



// WEBPACK FOOTER //
// src/App.vue